export enum TooltipInfoCopy {
  SampleDistance = 'Includes all points within this distance from the selected line, on both sides.',
}

export enum DxfAxisLabelAlignment {
  Center = 'center',
  Top = 'top',
  Middle = 'middle'
}
